// extracted by mini-css-extract-plugin
module.exports = {"PdfEditor":"PdfEditor_PdfEditor__3ZBqP","Viewer":"PdfEditor_Viewer__2D6Hj","Btn":"PdfEditor_Btn__2G0nQ"};